export const TRANSPORTES = [
  { value: 'PROPRIO', label: 'Próprio', hex: '#3366cc' },
  { value: 'ONIBUS', label: 'Ônibus', hex: '#e67e22' }
]

export function getTransporte(value) {
  return TRANSPORTES.find(t => t.value === value) || null
}
